/**
 * RPM — Retail Performance Metrics (Supervisor Daily Ops).
 *
 * Default export renders the RPM route tree so App.tsx wiring stays the same.
 */

import { Routes, Route } from 'react-router';
import { SplatRedirect } from '@/components/common/SplatRedirect';
import { SupervisorHome } from './SupervisorHome';
import { DrillThroughRecord } from './DrillThroughRecord';
import { AdminThresholds } from './components/AdminThresholds';
import { CartResolutionTab } from './CartResolutionTab';
import './rpm.css';

export default function RPM(): JSX.Element {
  return (
    <Routes>
      <Route index element={<SupervisorHome />} />
      <Route path="drill/:kpiKey" element={<DrillThroughRecord />} />
      <Route path="admin/thresholds" element={<AdminThresholds />} />
      <Route path="cart-resolution" element={<CartResolutionTab />} />
      <Route path="*" element={<SplatRedirect />} />
    </Routes>
  );
}
